import { createContext } from 'react';
import { MaxBreakpointsTypes } from '../../models/breakpoints';

type BreakpointContextType = Partial<Record<MaxBreakpointsTypes, boolean>>;

export const BreakpointContext = createContext<BreakpointContextType>({});
